export const sampleConcepts = [
  {
    label: 'Agent memory loop',
    conceptText: 'Show a one-off task becoming reusable memory, then improving the next agent run.',
    articleContext: 'An article about agents becoming more useful when they remember durable lessons.',
    grammar: 'loop'
  },
  {
    label: 'Messy notes to outline',
    conceptText: 'Animate scattered notes clustering into a clean article outline with three sections.',
    articleContext: 'A writing workflow article.',
    grammar: 'transformation'
  },
  {
    label: 'Local render pipeline',
    conceptText: 'Show browser preview, worker queue, local renderer, MP4, GIF, and exported article as a pipeline.',
    articleContext: 'A technical walkthrough of Animated Graphics Lab.',
    grammar: 'sequence'
  }
] as const;
